import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App as AntdApp } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './app/app.js';
import './styles.css';

try {
  const current =
    (globalThis as unknown as { importMetaEnv?: Record<string, unknown> }).importMetaEnv || {};
  (globalThis as unknown as { importMetaEnv?: Record<string, unknown> }).importMetaEnv = {
    ...current,
    VITE_IDP_BASE_URL: import.meta.env['VITE_IDP_BASE_URL'],
    VITE_IDP_AUDIENCE: import.meta.env['VITE_IDP_AUDIENCE'],
    VITE_YOLO_API_URL: import.meta.env['VITE_YOLO_API_URL'],
    VITE_AXIZ_API_URL: import.meta.env['VITE_AXIZ_API_URL'],
  } as Record<string, unknown>;
} catch {
  // ignore if not in a browser context
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AntdApp>
          <App />
        </AntdApp>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
